export const SHOP_CURRENT_ROUTE = 'shops/shop';
